<ng-container>
  <portal-file-drop
    [accept]="accept"
    [hasFile]="hasFile"
    [maxFileSize]="maxFileSize"
    (dropped)="setFile($event[0])"
    (rejected)="rejectedFiles = $event"
  >
    <span *portalTransclude="'title'; let action = action">
      {{ 'common.file.' + action | translate }}
    </span>
  </portal-file-drop>

  @if (rejectedFiles != null) {
    <ngb-alert [dismissible]="false" type="warning">
      <portal-file-rejected-description
        [multiple]="false"
        [rejectedFiles]="rejectedFiles"
      ></portal-file-rejected-description>
    </ngb-alert>
  }

  <portal-progress-button
    [btnClass]="btnClass"
    [disabled]="disabled"
    [progress]="progress"
    [progressText]="progressText"
    (clicked)="onButtonClicked()"
    ><ng-content></ng-content
  ></portal-progress-button>

  <input class="file-select__input" #file [accept]="accept" (change)="setFile(file.files[0])" type="file" />
</ng-container>
